import request from '@/utils/request'

// 查询轨道交通站点列表
export function listStation(query) {
  return request({
    url: '/admin/metro/station/list',
    method: 'get',
    params: query
  })
}

// 查询轨道交通站点详细
export function getStation(stationId) {
  return request({
    url: '/admin/metro/station/getInfo?stationId=' + stationId,
    method: 'get'
  })
}

// 新增轨道交通站点
export function addStation(data) {
  return request({
    url: '/admin/metro/station',
    method: 'post',
    data: data
  })
}

// 修改轨道交通站点
export function updateStation(data) {
  return request({
    url: '/admin/metro/station',
    method: 'put',
    data: data
  })
}

// 修改轨道交通站点状态
export function updateStatus(stationId,stationStatus) {
  const data = {
    stationId,
    stationStatus
  }
  return request({
    url: '/admin/metro/station/updateStatus',
    method: 'put',
    data: data
  })
}

// 删除轨道交通站点
export function delStation(stationId) {
  return request({
    url: '/admin/metro/station/deleteStation?stationId=' + stationId,
    method: 'delete'
  })
}
